import React from 'react';
import {Body, Headline, Label, Tooltip} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './StatBox.module.scss';

export interface StatBoxProps {
  label: string;
  values: string[];
  sublabel?: string;
  maxShown?: number;
  testID?: string;
}

function StatBox({
  label,
  values,
  sublabel,
  maxShown = 1,
  testID = 'stat-box',
}: StatBoxProps) {
  const visible = values.slice(0, maxShown);
  const extra = values.length - maxShown;
  const extraTooltip = values.slice(maxShown).join(', ');

  return (
    <div className={styles.container} data-testid={testID}>
      <Label size="xs" className={styles.label}>
        {label}
      </Label>
      <Headline size="md" className={styles.value}>
        {visible.join(', ')}
      </Headline>
      {sublabel ? (
        <Body size="sm" className={styles.sublabel}>
          {sublabel}
        </Body>
      ) : null}
      {extra > 0 ? (
        <Tooltip title={extraTooltip} placement="bottom">
          <span className={styles.tooltipTrigger}>
            +{extra} {translate('More')}
          </span>
        </Tooltip>
      ) : null}
    </div>
  );
}

export default StatBox;
